import { Horse } from '../types/content';

export const horses: Horse[] = [
  {
    id: 'mesi',
    name: 'Mesi',
    group: 'calm',
    age: 14,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/1a391daf-86c5-45f8-ad9b-05de7abfd71b.jpg',
    breed: { en: 'Arabian', ru: 'Арабская', et: 'Araabia' },
    temperament: {
      en: 'Patient and steady — our favourite for first rides.',
      ru: 'Терпеливая и надёжная — наша любимица для первых прогулок.',
      et: 'Kannatlik ja kindel — meie lemmik esimesteks sõitudeks.',
    },
  },
  {
    id: 'liisu',
    name: 'Liisu',
    group: 'calm',
    age: 17,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b8e354ac-49f8-4e56-bb1c-3dd185e72ed4.jpg',
    breed: { en: 'Arabian', ru: 'Арабская', et: 'Araabia' },
    temperament: {
      en: 'Calm and wise, knows every forest path by heart.',
      ru: 'Спокойная и мудрая, знает каждую лесную тропу.',
      et: 'Rahulik ja tark, tunneb iga metsarada peast.',
    },
  },
  {
    id: 'kaspar',
    name: 'Kaspar',
    group: 'calm',
    age: 12,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ee062027-ab59-4c3b-8d98-c13efba47396.jpg',
    breed: { en: 'Arabian', ru: 'Арабская', et: 'Araabia' },
    temperament: {
      en: 'Gentle and forgiving, great for nervous riders.',
      ru: 'Мягкий и прощающий ошибки, хорош для неуверенных всадников.',
      et: 'Õrn ja andestav, sobib hästi närvilistele ratsanikele.',
    },
  },
  {
    id: 'kirju',
    name: 'Kirju',
    group: 'calm',
    age: 11,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/88bcbf9a-7bf4-42dd-88c6-9717ab409e5d.jpg',
    breed: { en: 'Arabian', ru: 'Арабская', et: 'Araabia' },
    temperament: {
      en: 'Sturdy and relaxed, loves walking along the beach.',
      ru: 'Крепкий и спокойный, обожает прогулки по пляжу.',
      et: 'Tugev ja rahulik, armastab rannas jalutada.',
    },
  },
  {
    id: 'oo',
    name: 'Öö',
    group: 'advanced',
    age: 9,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7e824116-d5fe-4a05-a618-2df9da7a164c.jpg',
    breed: { en: 'Arabian · endurance', ru: 'Арабская · пробеги', et: 'Araabia · kestvussõit' },
    temperament: {
      en: 'Forward and powerful, lives for a canter on the sand.',
      ru: 'Энергичный и мощный, обожает галоп по песку.',
      et: 'Edasipüüdlik ja jõuline, armastab galoppi liival.',
    },
  },
  {
    id: 'leek',
    name: 'Leek',
    group: 'advanced',
    age: 8,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/982c71ef-2ad1-44be-99aa-11602bae6eb1.jpg',
    breed: { en: 'Arabian · endurance', ru: 'Арабская · пробеги', et: 'Araabia · kestvussõit' },
    temperament: {
      en: 'Energetic and responsive, for confident riders.',
      ru: 'Энергичная и чуткая, для уверенных всадников.',
      et: 'Energiline ja tundlik, kindlatele ratsanikele.',
    },
  },
  {
    id: 'torm',
    name: 'Torm',
    group: 'advanced',
    age: 10,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8342ff7f-6644-4202-b2bf-853d9a8af5fe.jpg',
    breed: { en: 'Arabian · endurance', ru: 'Арабская · пробеги', et: 'Araabia · kestvussõit' },
    temperament: {
      en: 'Strong and brave in any terrain.',
      ru: 'Сильный и смелый на любом рельефе.',
      et: 'Tugev ja julge igal maastikul.',
    },
  },
  {
    id: 'sepp',
    name: 'Sepp',
    group: 'advanced',
    age: 12,
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8915816f-0a9e-4b9d-a45b-63251cf64e89.jpg',
    breed: { en: 'Arabian · endurance', ru: 'Арабская · пробеги', et: 'Araabia · kestvussõit' },
    temperament: {
      en: 'Sensitive and light in the hand — a rewarding ride.',
      ru: 'Чуткий и лёгкий в поводу — удовольствие для опытного всадника.',
      et: 'Tundlik ja kerge käes — nauditav sõit.',
    },
  },
];
